import { EMPTY_OBJECT } from '../constants/common'
import { getApi } from '../utils/api'

export function getFunctionalRoleList({ options, params } = EMPTY_OBJECT) {
  return getApi({ endpoint: 'api/v2/functional-role/', options, params })
}
